import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { RequestServiceService } from '../../core/services/request-service/request-service.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment.prod';
import { MessagesService } from 'src/app/core/services/messages/messages.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  pwdType: any = true;
  registrationForm: FormGroup;
  submitted = false;
  incorrect: boolean = false;
  message: String = "";
  confirmPwdType: boolean = true;


  constructor(
    private fb: FormBuilder,
    private requestApiService: RequestServiceService,
    private authService: AuthService, private messageservices: MessagesService,
    private router: Router
  ) {
    this.registrationForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      country_code: ['+971', [Validators.required]],
      mobile: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_password: ['', [Validators.required, Validators.minLength(8)]],
    }, { validator: this.passwordMatchValidator });

  }
  passwordMatchValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirm_password');
    return password && confirmPassword && password.value !== confirmPassword.value
      ? { 'passwordMismatch': true }
      : null;
  };
  noSpecialCharactersValidator(): ValidatorFn {
    // Define a regular expression pattern to match special characters
    const pattern = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]+/;
    return (control: AbstractControl): { [key: string]: any } | null => {
      const forbidden = pattern.test(control.value);
      return forbidden ? { 'forbiddenCharacters': { value: control.value } } : null;
    };
  }

  ngOnInit() {

  }

  get f() { return this.registrationForm.controls; }
  onInput(event: any): void {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    input.value = currentValue.replace(/[^a-zA-Z ]/g, ''); // Replace any character that is not a letter or space
  }
  
  onSubmit() {
    this.submitted = true
   
    if (this.registrationForm.valid) {
      // Handle form submission, e.g., send data to your server
      const formData = this.registrationForm.value;

      this.requestApiService.signUp(formData).then(response => {

        this.submitted = false
        if (response.success) {
          this.message = response.msg;
          this.messageservices.showNotification(response.msg, 'success', 'success');
          this.router.navigate(['/otp'], { state: { data: this.registrationForm.value.email, mob: this.registrationForm.value.mobile } });
        } else {
          this.message = response.msg;
          this.messageservices.showNotification(response.msg, 'success', 'success');
        }
      });
    } else {
      // Mark form controls as touched to display validation errors
      this.registrationForm.markAllAsTouched();
    }
  }
  togglePwdType = () => {
    this.pwdType = !this.pwdType;
  }
  toggleConfirmPwdType = () => {
    this.confirmPwdType = !this.confirmPwdType;
  }
}
